import { render, staticRenderFns } from "./TreatmentComposition.vue?vue&type=template&id=5bce5d74&scoped=true"
import script from "./TreatmentComposition.vue?vue&type=script&lang=js"
export * from "./TreatmentComposition.vue?vue&type=script&lang=js"
import style0 from "./TreatmentComposition.vue?vue&type=style&index=0&id=5bce5d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bce5d74",
  null
  
)

export default component.exports